import { authAPI } from '../utils/api';
import React, { createContext, useContext, useState, useEffect } from 'react';

const Ctx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const u = localStorage.getItem('tnpsc_user');
      const a = localStorage.getItem('tnpsc_admin');
      const t = localStorage.getItem('tnpsc_token');
      if (t && u) setUser(JSON.parse(u));
      if (t && a) setAdmin(JSON.parse(a));
    } catch {}
    setLoading(false);
  }, []);

  const loginUser = (token, userData) => {
    localStorage.setItem('tnpsc_token', token);
    localStorage.setItem('tnpsc_user', JSON.stringify(userData));
    setUser(userData);
  };

  const loginAdmin = (token, adminData) => {
    localStorage.setItem('tnpsc_token', token);
    localStorage.setItem('tnpsc_admin', JSON.stringify(adminData));
    setAdmin(adminData);
  };

  const logout = async () => {
    try { await authAPI.logout(); } catch {} // clear token from DB
    localStorage.removeItem('tnpsc_token');
    localStorage.removeItem('tnpsc_user');
    localStorage.removeItem('tnpsc_admin');
    setUser(null);
    setAdmin(null);
    window.location.href = '/login';
  };

  const updateUser = (data) => {
    const updated = { ...user, ...data };
    setUser(updated);
    localStorage.setItem('tnpsc_user', JSON.stringify(updated));
  };

  return (
    <Ctx.Provider value={{ user, admin, loading, loginUser, loginAdmin, logout, updateUser, isLoggedIn: !!user, isAdmin: !!admin }}>
      {children}
    </Ctx.Provider>
  );
};

export const useAuth = () => useContext(Ctx);
